"use strict";
define(
'stores/email-activities',[
	"jquery",
	"stores/store",
	"actions/email-activities",
	"constants/actiontypes"
],
function ($, StoreBase, Action, Constants)
{
	Store.prototype = new StoreBase();
	Store.constructor = Store;

	var PAGE_SIZE = 10;

	function Store (params)
	{
		// Call parent constructor
		StoreBase.call(this, params);

		this.registerDispatchListener(function (action) {
			switch(action.actionType) {
				case Constants.INIT_EMAIL_ACTIVITIES:
					_.each(action.data, function (data, index, list) {
						this.addEmailActivity(data);
					}, this);
					this.initFilteredResults();
					this.event.emit("change");
					break;
				case Constants.REFRESH_EMAIL_ACTIVITY:
					this.updateEmailActivity(action.data);
					this.event.emit("change");
					break;
			}
		}.bind(this));

		this.action = new Action();
		this.keyword = null;
	}

	Store.prototype.pull = function() {
		this.emailActivities = {};
		this.filteredResults = [];
		this.action.pull();
	}

	Store.prototype.addEmailActivity = function(data) {
		this.emailActivities[data.buncee_guid] = data;
	}

	Store.prototype.getAll = function(page) {
		var ret = this.filteredResults.slice(page*PAGE_SIZE, (page+1)*PAGE_SIZE);
		return ret;
	}

	Store.prototype.getBuncee = function(bunceeGUID) {
		var ret = this.emailActivities[bunceeGUID];
		return ret;
	}

	Store.prototype.getMaxPage = function() {
		return Math.floor((this.filteredResults.length-1) / PAGE_SIZE);
	}

	Store.prototype.refreshEmailActivity = function(buncee_guid) {
		this.action.refresh(buncee_guid);
	}

	Store.prototype.updateEmailActivity = function(data) {
		this.emailActivities[data.buncee_guid] = data;
	}

	Store.prototype.initFilteredResults = function() {
		var self = this;

		var regExp = null;
		if(this.keyword) {
			regExp = this.keyword ? new RegExp(this.keyword.replace(/ /g, "|"), "i") : null;
		}

		this.filteredResults = [];
		_.each(this.emailActivities, function(ea) {
			if(!regExp || regExp.test(ea.title))
				self.filteredResults.push(ea);
		});

		this.filteredResults.sort(function(a, b) {
			var aTime = a.created_at;
			var bTime = b.created_at;

			if(aTime > bTime)
				return -1;
			else if(aTime < bTime)
				return 1;
			return 0;
		});
	}

	Store.prototype.initSearch = function(keyword) {
		this.keyword = (keyword.trim().length < 3) ? null : keyword.trim();
		this.initFilteredResults();
	}

	return Store;
});

